import { createEventFactory, createName } from '@cp/shared/tracking';
import { CatalogViewMode } from '../model';

export const CatalogEvents = {
  ViewModeChange: createEventFactory<CatalogViewMode>({
    name: createName('catalog', 'view', 'change'),
    goalId: 'nazhatie_na_knopku_smotret_na_karte_v_filtre_listinga',
    goalName: 'Нажатие на кнопку "Смотреть на карте" в фильтре листинга',
  }),
  FilterCityChange: createEventFactory({
    name: createName('catalog', 'fiter', 'city'),
    goalId: 'smena_goroda_v_filtre_listinga',
    goalName: 'Смена города в фильтре листинга',
  }),
  FilterDateChange: createEventFactory({
    name: createName('catalog', 'filter', 'date'),
    goalName: 'Выбор даты заказа в фильтре листинга',
    goalId: 'vybor_daty_zakaza_v_filtre_listinga',
  }),
  FilterTimeChange: createEventFactory({
    name: createName('catalog', 'filter', 'time'),
    goalId: 'vybor_vremeni_zakaza_v_filtre_listinga',
    goalName: 'Выбор времени заказа в фильтре листинга',
  }),
  FilterShowAvailable: createEventFactory({
    name: createName('catalog', 'filter', 'available'),
    goalName: 'Выбор селектора "Показать только доступных репититоров" в фильтре листинга',
    goalId: 'vybor_selektora_pokazat_tolko_dostupnyh_repititorov_v_filtre_listinga',
  }),
  FilterPriceChange: createEventFactory({
    name: createName('catalog', 'filter', 'price'),
    goalId: 'vybor_filra_stoimosti_v_listinga',
    goalName: 'Выбор фильра стоимости в листинга',
  }),
  FilterOpen: createEventFactory({ name: createName('catalog', 'filter', 'open') }),
  ItemClick: createEventFactory({
    name: createName('catalog', 'item', 'click'),
    goalId: 'vybor_ob"yavleniya_v_listinge',
    goalName: 'Выбор объявления в листинге',
  }),
  ItemLike: createEventFactory({
    name: createName('catalog', 'item', 'like'),
    goalId: 'nazhatie_knopki_dobavit_v_izbrannoe',
    goalName: 'Нажатие кнопки "Добавить в избранное"',
  }),
  ItemInvite: createEventFactory({
    name: createName('catalog', 'item', 'invite'),
    goalId: 'nazhatie_knopki_otpravit_priglashenie_',
    goalName: 'Нажатие кнопки "Отправить приглашение" ',
  }),
  ItemResponse: createEventFactory({
    name: createName('catalog', 'item', 'response'),
    goalId: 'nazhatie_na_knopku_ya_mogu_v_ob"yavlenii',
    goalName: 'Нажатие на кнопку "Я могу" в объявлении',
  }),
  ItemQuestion: createEventFactory({
    name: createName('catalog', 'item', 'question'),
    goalId: 'nazhatie_na_knopku_zadat_vopros_v_ob"yavlenii',
    goalName: 'Нажатие на кнопку "Задать вопрос" в объявлении',
  }),
} as const;
